/**
 * Abre o WhatsApp em uma nova janela com o número de telefone fornecido
 * @param numeroTelefone - Número de telefone sem formatação (ex: 86995233237)
 */
export function openWhatsApp(numeroTelefone: string) {
  if (!numeroTelefone) {
    console.warn("Número de telefone não fornecido");
    return;
  }

  // Remove caracteres não numéricos
  const numero = numeroTelefone.replace(/\D/g, "");

  // Abre o WhatsApp em uma nova janela
  window.open(`https://wa.me/55${numero}`, "_blank", "noopener,noreferrer");
}

/**
 * Formata um número de telefone para exibição com máscara no padrão brasileiro
 * @param numeroTelefone - Número de telefone sem formatação (ex: 86995233237)
 * @returns Número formatado (ex: (86) 99523-3237)
 */
export function formatarTelefoneMascara(numeroTelefone: string): string {
  if (!numeroTelefone) return "";

  // Remove caracteres não numéricos
  let numero = numeroTelefone.replace(/\D/g, "");

  // Se tiver 11 dígitos (celular com 9)
  if (numero.length === 11) {
    numero = numero.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  // Se tiver 10 dígitos (celular com 8)
  else if (numero.length === 10) {
    numero = numero.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }

  return numero;
}
